import * as React from 'react';

import { MapServices } from 'shared/components/MapServices';

import { useMapServices } from './hooks';
import { EMapService } from '../../../../types/map';

export interface IMapServicesContainerProps {
  onServiceClick: (service: EMapService) => void;
}

export const MapServicesContainer: React.FC<IMapServicesContainerProps> = ({ onServiceClick }) => {
  const serviceTypes = useMapServices();

  return <MapServices onServiceClick={onServiceClick} serviceTypes={serviceTypes} />;
};
